import {XHTTP} from '@/shared/xhttp';
import {AchatService} from "@/xhttp";
import {Address} from './Address';
import {EssenceAchat} from '@/models/EssenceAchat';
import {Client} from "@/models/Client";
import {Transporteur} from "@/models/Transporteur";
import {LongueursAchat} from "@/models/LongueursAchat";
import {DateHelper} from "@/shared/utils";
import {Vente} from "@/models/Vente";
import {Fournisseur} from "@/models/Fournisseur";
import {SuiviReglement} from "@/models/SuiviReglement";
import {AchatFrais} from "@/models/AchatFrais";
import {DocumentAchat} from "@/models/DocumentAchat";

@XHTTP(AchatService, '/achats')
export class Achat {

	private _id: number;
	private _date: Date = new Date();
	private _dateCoupe: Date = new Date();
	private _dateEnlevement: Date
	private _address: string;
	private _zipCode: string;
	private _town: string;
	private _country: string;
	private _totalPrice: number;
	private _fournisseur: Fournisseur;
	private _finCoupe: boolean;
	private _numero: string;
	private _lienLoca: string;
	private _lat: string; // Devenu coordonnées GSP
	private _lng: string; // plus utilisé
	private _acces: boolean;
	private _createdAt: Date;
	private _essenceAchats: EssenceAchat[];
	private _reglements: SuiviReglement[] = [];
	private _achatFrais: AchatFrais[] = [];
	private _montantRegler: number = 0.0;
	private _payer: boolean = false;
	private _documents: DocumentAchat[] = [];
	private _surPied: boolean = false;
	private _accesTempsSec: boolean = false;
	private _remarques: string;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get dateCoupe(): Date {
		return this._dateCoupe;
	}

	public get dateEnlevement(): Date {
		return this._dateEnlevement;
	}

	public get address(): string {
		return this._address;
	}

	public get zipCode(): string {
		return this._zipCode;
	}

	public get town(): string {
		return this._town;
	}

	public get country(): string {
		return this._country;
	}

	public get fullAddress(): string {
		return (this.address.trim()+' '+this.zipCode.trim()+' '+this.town.trim()).trim();
	}

	public get totalPrice(): number {
		return this._totalPrice;
	}

	public get formatedPrice(): string {
		return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(this._totalPrice)
	}

	public get fournisseur(): Fournisseur {
		return this._fournisseur;
	}

	public get nameWithNumber(): string {
		return this._fournisseur.name + " | " + this._address + " | " + this._numero;
	}

	public get finCoupe(): boolean {
		return this._finCoupe;
	}

	public get numero(): string {
		return this._numero;
	}

	public get lienLoca(): string {
		return this._lienLoca;
	}

	public get lat(): string {
		return this._lat;
	}

	public get lng(): string {
		return this._lng;
	}

	public get acces(): boolean {
		return this._acces;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	public get essenceAchats(): EssenceAchat[] {
		return this._essenceAchats;
	}

	public get reglements(): SuiviReglement[] {
		return this._reglements;
	}

	public get achatFrais(): AchatFrais[] {
		return this._achatFrais;
	}

	public get montantRegler(): number {
		return this._montantRegler;
	}

	public get payer(): boolean {
		return this._payer;
	}

	public get documents(): DocumentAchat[] {
		return this._documents;
	}

	public get surPied(): boolean {
		return this._surPied;
	}

	public get accesTempsSec(): boolean {
		return this._accesTempsSec;
	}

	public get remarques(): string {
		return this._remarques;
	}

	/////////////
	// Setters //
	/////////////

	public set id(value: number) {
		this._id = value;
	}

	public set date(value: Date) {
		this._date = value;
	}

	public set dateCoupe(value: Date) {
		this._dateCoupe = value;
	}

	public set dateEnlevement(value: Date) {
		this._dateEnlevement = value;
	}
	public set address(value: string) {
		this._address = value;
	}

	public set zipCode(value: string) {
		this._zipCode = value;
	}

	public set town(value: string) {
		this._town = value;
	}

	public set country(value: string) {
		this._country = value;
	}

	public set totalPrice(value: number) {
		this._totalPrice = value;
	}

	public set fournisseur(value: Fournisseur) {
		this._fournisseur = value;
	}

	public set finCoupe(value: boolean) {
		this._finCoupe = value;
	}

	public set numero(value: string) {
		this._numero = value;
	}

	public set lienLoca(value: string) {
		this._lienLoca = value;
	}

	public set lat(value: string) {
		this._lat = value;
	}

	public set lng(value: string) {
		this._lng = value;
	}

	public set acces(value: boolean) {
		this._acces = value;
	}

	public set reglements(value: SuiviReglement[]) {
		this._reglements = value;
	}

	public set achatFrais(value: AchatFrais[]) {
		this._achatFrais = value;
	}

	public set montantRegler(value: number) {
		this._montantRegler = value;
	}

	public set payer(value: boolean) {
		this._payer = value;
	}

	public set surPied(value: boolean) {
		this._surPied = value;
	}

	public set accesTempsSec(value: boolean) {
		this._accesTempsSec = value;
	}

	public set remarques(value: string) {
		this._remarques = value;
	}

	/////////
	// Add //
	/////////

	public addDocuments(document: DocumentAchat): this {
		document.achat = this;
		if (this._documents.indexOf(document) === -1) {
			this._documents.push(document);
		}
		return this;
	}

	public removeDocuments(document: DocumentAchat): this {
		document.achat = this;
		const index = this._documents.indexOf(document);
		if (index !== -1) {
			this._documents.splice(index, 1);
		}
		return this;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id       : this._id,
			date    : this._date ? DateHelper.toLocalizedString(this._date) : null,
			dateCoupe    : this._dateCoupe ? DateHelper.toLocalizedString(this._dateCoupe) : null,
			dateEnlevement    : this._dateEnlevement ? DateHelper.toLocalizedString(this._dateEnlevement) : null,
			address : this._address,
			zipCode : this._zipCode,
			town : this._town,
			country : this._country,
			totalPrice : this._totalPrice,
			fournisseur  : this._fournisseur ? this._fournisseur.id : null,
			finCoupe   : this._finCoupe,
			numero : this._numero,
			lienLoca : (this._lienLoca && this._lienLoca.includes('http')) ? this._lienLoca.substring(this._lienLoca.indexOf("http"), this._lienLoca.length) : this._lienLoca,
			lat : this._lat, // Coordonnés GPS
			lng : this._lng, // plus utilisé
			acces : this._acces,
			suiviReglements: this._reglements ? this._reglements.map(r => r.toJSON()) : [],
			montantRegler : this._montantRegler,
			payer        : this._payer,
			surPied        : this._surPied,
			accesTempsSec        : this._accesTempsSec,
			remarques        : this._remarques,
			achatFrais: this._achatFrais ? this._achatFrais.map(r => r.toJSON()) : [],
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._dateCoupe         = data.dateCoupe ? DateHelper.fromLocalizedString(data.dateCoupe) : null;
		this._dateEnlevement         = data.dateEnlevement ? DateHelper.fromLocalizedString(data.dateEnlevement) : null;
		this._address  = data.address;
		this._zipCode  = data.zipCode;
		this._town  = data.town;
		this._country  = data.country;
		this._totalPrice  = data.totalPrice;
		this._fournisseur   = data.fournisseur ? (new Fournisseur()).fromJSON(data.fournisseur) : null;
		this._finCoupe    = data.finCoupe;
		this._numero  = data.numero ? data.numero.toUpperCase() : '';
		this._lienLoca  = data.lienLoca;
		this._lat  = data.lat; // Coordonnés GPS
		this._lng  = data.lng; // plus utilisé
		this._acces  = data.acces;
		this._createdAt    = data.createdAt ? new Date(data.createdAt) : null;
		this._essenceAchats = data.essenceAchats ? data.essenceAchats.map(c => (new EssenceAchat()).fromJSON(c)) : null;
		if (this._essenceAchats) {
			for (const essence of this._essenceAchats) {
				essence.achat = this;
			}
		}
		this._reglements                = data.suiviReglements ? data.suiviReglements.map(r => (new SuiviReglement()).fromJSON(r)) : [];
		this._montantRegler                   = data.montantRegler;
		this._payer                   = data.payer;
		if (data.documentAchats)  {
			for (const d of data.documentAchats) {
				this.addDocuments((new DocumentAchat()).fromJSON(d));
			}
		}
		this._surPied = data.surPied;
		this._accesTempsSec = data.accesTempsSec;
		this._remarques = data.remarques;
		this._achatFrais                = data.achatFrais ? data.achatFrais.map(r => (new AchatFrais()).fromJSON(r)) : [];
		return this;
	}
}
